<app-layout-loading [backgroundColor]="ColorsConstants.SURFACE_DARK" [showLoading]="isLoading | async">
  <app-statistics-chart-filter
    (filterChanged)="onStatisticsFilterChanged($event)"
    [searchKey]="'statisticsFilter'"
    [cardsData]="cardsData"
  ></app-statistics-chart-filter>
  <app-statistics-chart [data]="chartData" [labels]="labels"></app-statistics-chart>
</app-layout-loading>
